<template>
  <div class="mt-3">
    <div class="row">
      <div class="col">
        <b-form-checkbox v-model="config.ativo"
                         name="check-button"
                         :disabled="table.busy"
                         value="1"
                         unchecked-value="0"
                         switch
                         @change="valor => atualizarStatus(valor)">
          <b>
            Controle de impresso de segurança:
            <span v-if="config.ativo === '1'"
                  class="text-primary">Ativo</span>
            <span v-else
                  class="text-danger">Desativado</span>
          </b>
        </b-form-checkbox>
      </div>
      <hr>
    </div>
    <div class="row">
      <!--<div class="col-2">
        <label class="label">
          Mostrar lote
        </label>
        <select class="form-control form-control-sm">
          <option>Em utilização</option>
        </select>
      </div>-->
      <div class="col-2">
        <label class="label">
          Mostrar lote
        </label>
        <select v-model="search.status"
                class="form-control form-control-sm"
                @change="init(true)">
          <option value="ATIVOS">
            Ativos
          </option>
          <option value="FINALIZADOS">
            Finalizados
          </option>
          <option value="TODOS">
            Todos
          </option>
        </select>
      </div>
      <div class="col-2">
        <label class="label">
          Tipo de impresso
        </label>
        <select v-model="search.tipo_papel"
                class="form-control form-control-sm"
                @change="init(true)">
          <optgroup label="Tipo de impresso">
            <option key="todos"
                    value="todos">
              Todos
            </option>
          </optgroup>
          <optgroup label="Papéis">
            <option v-for="tipo in tipos_de_papeis"
                    :key="tipo.value"
                    :value="tipo.value">
              {{ tipo.label }}
            </option>
          </optgroup>
          <optgroup label="Selos">
            <option v-for="tipo in tipos_de_selos"
                    :key="tipo.value"
                    :value="tipo.value">
              {{ tipo.label }}
            </option>
          </optgroup>
        </select>
      </div>
      <div class="col-2">
        <label class="label">
          Data do lote
        </label>
        <input v-model="search.data_lote"
               class="form-control form-control-sm"
               type="date"
               @change="init()">
      </div>
      <div class="col mt-4">
        <button class="btn btn-sm btn-outline-primary"
                @click="resetBusca()">
          Limpar busca
        </button>
      </div>
      <div class="col text-right mt-4 d-flex">
        <button class="btn btn-sm btn-secondary mr-2 btn-alerta"
                @click="modal.alerta = true">
          Alerta de papel
        </button>
        <button class="btn btn-sm btn-secondary"
                :disabled="config.ativo === '0'"
                @click="lote.show = true">
          <icon-svg icon="add"
                    class="icons--white icon--xs" />
          Adicionar lote
        </button>
      </div>
    </div>
    <!-- inicio listagem lotes -->
    <div class="row mt-4">
      <div class="col">
        <b-table :fields="search.status !== 'FINALIZADOS' ? table.fields : table.fieldsFinalizados"
                 :items="lotes"
                 outlined
                 striped
                 :busy="table.busy"
                 class="text-center"
                 thead-class="PapelSegurancaLote_table--header"
                 tbody-tr-class="thead-row-class"
                 show-empty
                 @row-clicked="(lote) => goToLoteDetalhes(lote)">
          <template #table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle mr-2 icon--sm" />

              <strong>Carregando...</strong>
            </div>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center">
              Sem registros
            </div>
          </template>
          <template slot="key_inicial_final"
                    slot-scope="data">
            <div class="text-left pointer">
              {{ data.item.prefixo_inicial }}{{ data.item.numero_inicial }} - {{ data.item.prefixo_final }}{{ data.item.numero_final }}
            </div>
          </template>
          <template slot="key_tipo_papel"
                    slot-scope="data">
            <div class="text-left pointer">
              {{ data.item.tipo_papel }}
            </div>
          </template>
          <template slot="key_quantidade_total"
                    slot-scope="data">
            <div class="text-left pointer">
              {{ data.item.quantidade_papel }}
            </div>
          </template>
          <template slot="key_data_lote"
                    slot-scope="data">
            <div class="text-left pointer">
              {{ data.item.data_lote | date }}
            </div>
          </template>
          <template slot="key_porcentagem"
                    slot-scope="data">
            <div class="text-left pointer">
              {{ data.item.porcentagem_usada.toFixed(0) }}%
              <b-progress :min="0"
                          class="progress-bar"
                          :style="{ 'background-color': '#C2F0E9'}"
                          :max="100"
                          height="1rem">
                <b-progress-bar :value="data.item.porcentagem_usada" />
              </b-progress>
            </div>
          </template>
          <template slot="key_acoes"
                    slot-scope="data">
            <div class="d-flex mt-2">
              <button v-if="search.status !== 'FINALIZADOS'"
                      class="btn btn-sm btn-danger mr-2"
                      @click="deleteLote(data.item)">
                Excluir
              </button>
              <b-dropdown right
                          block="true"
                          text="Visualizar"
                          size="sm">
                <b-dropdown-item @click="showModalLote(data.item)">
                  Detalhes
                </b-dropdown-item>
                <b-dropdown-item @click="goToLoteDetalhes(data.item)">
                  Impressos
                </b-dropdown-item>
              </b-dropdown>
              <!--                <button class="btn btn-sm btn-danger  mr-2"-->
              <!--                        @click="deleteLote(data.item)">-->
              <!--                  Excluir lote-->
              <!--                </button>-->
              <!--                <button class="btn btn-sm btn-outline-secondary"-->
              <!--                        @click="showModalLote(data.item)">-->
              <!--                  Mostrar detalhes-->
              <!--                </button>-->
            </div>
          </template>
        </b-table>

        <Pagination v-if="lotes.length > 0"
                    :page="pagination.page"
                    :last-page="pagination.lastPage"
                    :select-page="true"
                    @onPreviousPage="changePage(pagination.page - 1)"
                    @onNextPage="changePage(pagination.page + 1)"
                    @onSetPage="page => changePage(page)" />
      </div>
    </div>

    <papel-seguranca-lote-adicionar v-if="lote.show"
                                    @onCloseModal="lote.show = false"
                                    @onSaveLote="lote => saveLote(lote)" />

    <b-modal v-if="modal.show"
             visible
             centered
             size="lg"
             hide-footer
             hide-header
             @hide="hideModalLote()">
      <div class="row">
        <div class="col">
          <small>CNS</small>
          <div><b>{{ cartorioObj.cns }}</b></div>
        </div>
        <div class="col">
          <small>Quantidade total</small>
          <div><b>{{ modal.lote.quantidade_papel }}</b></div>
        </div>
        <div class="col">
          <small>Quantidade disponível</small>
          <div><b>{{ modal.lote.quantidade_papel - modal.lote.quantidade_usados }}</b></div>
        </div>
        <div class="col">
          <small>Tipo de impresso</small>
          <div><b>{{ modal.lote.tipo_papel }}</b></div>
        </div>
      </div>
      <hr>
      <div class="text-right">
        <button class="btn btn-sm btn-outline-primary"
                @click="hideModalLote()">
          Voltar
        </button>
      </div>
    </b-modal>

    <b-modal v-if="modal.alerta"
             visible
             centered
             size="lg"
             hide-footer
             hide-header
             @hide="modal.alerta = false">
      <div class="row mb-4">
        <div class="col-12 text-center">
          <label class="label">
            Mostrar alerta de impresso quando restar:
          </label>
        </div>
      </div>
      <div v-for="(value, key, index) in config.impressos.papeis"
           :key="key"
           class="row">
        <div class="col-9">
          <label class="label mt-1">{{ tipos_de_papeis.find(item => key === tipoImpressoToAlerta(item.value)).label }}</label>
        </div>
        <div class="col-3">
          <input :id="key"
                 v-model="config.impressos.papeis[key]"
                 type="number"
                 min="0"
                 :class="`form form-control form-control-sm ${index !== config.impressos.papeis.length -1 ? 'mb-3' : ''}`">
        </div>
      </div>
      <hr>
      <div v-for="(value, key, index) in config.impressos.selos"
           :key="key"
           class="row">
        <div class="col-9">
          <label class="label mt-1">{{ tipos_de_selos.find(item => key === tipoImpressoToAlerta(item.value)).label }}</label>
        </div>
        <div class="col-3">
          <input :id="key"
                 v-model="config.impressos.selos[key]"
                 type="number"
                 min="0"
                 class="form form-control form-control-sm mb-3">
        </div>
      </div>
      <hr>
      <div class="text-right">
        <button class="btn btn-sm btn-alerta mr-2"
                @click="modal.alerta = false">
          Voltar
        </button>
        <button class="btn btn-sm btn-secondary"
                @click="atualizarAlerta">
          Atualizar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import PapelSegurancaLoteAdicionar from "@/components/SofiaRei/PapelSeguranca/PapelSegurancaLote/PapelSegurancaLoteAdicionar"
  import Pagination from '@/components/SofiaRei/Pagination'

  /* services */
  import PapelSegurancaLoteService from "@/services/PapelSeguranca/PapelSegurancaLoteService"
  import CartorioConfigService from '@/services/CartorioConfigService'

  /* libraries */
  import { mapGetters } from "vuex"

  /* helpers */
  import ErrorsPapelSegurancaLoteHelper from "@/helpers/Errors/PapelSeguranca/ErrorsPapelSegurancaLoteHelper"

  /* utils */
  import { tipoImpressoToAlerta } from '@/utils/impressoDeSeguranca'

  export default {
    name: "PapelSegurancaLote",
    components: {
      PapelSegurancaLoteAdicionar,
      Pagination
    },
    props: {
      propErro: {
        type: Object,
        default: () => ({
          status: false,
          message: null
        })
      }
    },
    data () {
      return {
        search: {
          data_lote: null,
          status: 'ATIVOS',
          tipo_papel: 'todos'
        },
        pagination: {
          page: 1,
          perPage: 10,
          lastPage: null
        },
        modal: {
          show: false,
          alerta: false,
          lote: {}
        },
        lote: {
          show: false,
          form: {}
        },
        lotes: [],
        table: {
          busy: false,
          fields: [
            {
              key: 'key_inicial_final',
              label: 'Número do lote',
              sortable: false
            },
            {
              key: 'key_tipo_papel',
              label: 'Tipo de impresso',
              sortable: false
            },
            {
              key: 'key_quantidade_total',
              label: 'Quantidade total',
              sortable: false
            },
            {
              key: 'key_data_lote',
              label: 'Data do lote',
              sortable: false
            },
            {
              key: 'key_porcentagem',
              label: 'Porcentagem de uso',
              sortable: false
            },
            {
              key: 'key_acoes',
              label: 'Ação',
              sortable: false
            }
          ],
          fieldsFinalizados: [
            {
              key: 'key_inicial_final',
              label: 'Número do lote',
              sortable: false
            },
            {
              key: 'key_tipo_papel',
              label: 'Tipo de impresso',
              sortable: false,
              tdClass: "tipo-impresso-column"
            },
            {
              key: 'key_quantidade_total',
              label: 'Quantidade total',
              sortable: false
            },
            {
              key: 'key_data_lote',
              label: 'Data do lote',
              sortable: false
            },
            {
              key: 'key_acoes',
              label: 'Ação',
              sortable: false,
              tdClass: "acao-column"
            }
          ]
        },
        config: {
          ativo: "0",
          num_alerta: null,
          impressos: {
            papeis: {},
            selos: {}
          }
        },
        tipos_de_papeis: [],
        tipos_de_selos: []
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj',
      }),
    },
    created () {
      this.init()
    },
    methods: {
      async init (restartPagination) {
        try {
          // verifica se existe erro para ser mostrado
          this.verifyErro()

          if (restartPagination) {
            this.pagination = {
              page: 1,
              perPage: 10,
              lastPage: null,
              total: null
            }
          }

          // carrega dados
          this.table.busy = true

          const [response, listTiposResponse, listAlertasResponse] = await Promise.all([
            PapelSegurancaLoteService.index({ ...this.search, ...this.pagination }),
            PapelSegurancaLoteService.listTipos(),
            CartorioConfigService.listAlertaImpressos()
          ])

          this.lotes = response.data
          this.pagination.lastPage = response.lastPage
          this.pagination.total = response.total
          this.tipos_de_papeis = listTiposResponse.tipos_de_papeis
          this.tipos_de_selos = listTiposResponse.tipos_de_selos

          listAlertasResponse.papeis.forEach(item => {
            this.config.impressos.papeis[item] = null
          })

          listAlertasResponse.selos.forEach(item => {
            this.config.impressos.selos[item] = null
          })

          await this.getStatusPapel()
          this.getNumAlerta()
        } catch (e) {
          if (e.response.data && e.response.data.message == 'Você não tem permissão para executar essa ação.') {
            objSwal.error.title = e.response.data.message
            Swal.fire(objSwal.error)
          }
        } finally {
          // loader({ active: false, text: '' })
          this.table.busy = false
        }
      },
      async saveLote (lote) {
        try {
          loader({ active: true, text: 'Salvando lote...' })
          const response = await PapelSegurancaLoteService.store(lote)

          if (response.success) {
            objSwal.success.title = 'Lote salvo!'
            Swal.fire(objSwal.success)
            objSwal.success.title = ''
          } else {
            objSwal.error.title = 'Erro ao salvar lote'

            // se existir retorno iremos pegar a mensagem
            if (!!response.message) {
              objSwal.error.text = ErrorsPapelSegurancaLoteHelper.getError(response.message)
            }
            Swal.fire(objSwal.error)
            objSwal.error.text = ''
            objSwal.error.text = ''
          }
        } catch (e) {
          if (e.response.data && e.response.data.message == 'Você não tem permissão para executar essa ação.') {
            objSwal.error.title = e.response.data.message
            Swal.fire(objSwal.error)
          }
        } finally {
          this.lote.show = false
          loader({ active: false, text: '' })
          this.init()
        }
      },
      async deleteLote (lote) {
        try {
          objSwal.question.title = `Deseja excluir o lote ${ lote.prefixo_inicial + lote.numero_inicial } - ${ lote.prefixo_final + lote.numero_final }?`
          const status = await Swal.fire(objSwal.question)

          if (status.value) {
            loader({ active: true, text: 'Excluindo lote...' })
            await PapelSegurancaLoteService.delete(lote.papel_seguranca_lote_id)

            objSwal.success.title = 'Lote excluído!'
            Swal.fire(objSwal.success)
            this.init()
          }
        } catch (e) {
          if (e.response.data && e.response.data.message == 'Você não tem permissão para executar essa ação.') {
            objSwal.error.title = e.response.data.message
            Swal.fire(objSwal.error)
            return
          }

          objSwal.error.title = 'Atenção!'
          objSwal.error.text = e.response.data.message
          Swal.fire(objSwal.error)
        } finally {
          loader({ active: false, text: '' })
          this.lote.show = false
        }
      },
      showModalLote (lote) {
        this.modal.show = true
        Object.assign(this.modal.lote, lote)
      },
      hideModalLote () {
        this.modal.show = false
        this.modal.lote = {}
      },
      goToLoteDetalhes (lote) {
        this.$router.push({
          name: 'papel_seguranca_lote_detalhes',
          params: {
            id: lote.papel_seguranca_lote_id
          }
        })
      },
      changePage (page) {
        this.pagination.page = page
        this.init()
      },
      resetBusca () {
        this.pagination.page = 1
        this.search.data_lote = null
        this.init()
      },
      verifyErro () {
        if (this.propErro.status) {
          objSwal.error.title = 'Atenção'
          objSwal.error.text = this.propErro.message
          Swal.fire(objSwal.error)
        }
      },
      async getStatusPapel () {
        try {
          const config = await CartorioConfigService.showByChave({
            chave: 'PAPEL_SEGURANCA_STATUS'
          })

          if (config) {
            // usamos !! para remover a string
            this.config.ativo = config.valor
          } else {
            // caso n tenha nada deixamos padrão false
            this.config.ativo = false
          }
        } catch (error) {
          let message
          if (error.response) {
            message = getErrors(error.response)
          } else {
            message = getErrors(error)
          }

          displayMessage('error', 'Erro!', message.message)
        }
      },
      async getNumAlerta () {
        try {
          const config = await CartorioConfigService.getAlertaImpressos()
          config.forEach(item => {
            if (item.chave in this.config.impressos.papeis) this.config.impressos.papeis[item.chave] = item.valor
            if (item.chave in this.config.impressos.selos) this.config.impressos.selos[item.chave] = item.valor
          })
        } catch (error) {
          let message
          if (error.response) {
            message = getErrors(error.response)
          } else {
            message = getErrors(error)
          }

          displayMessage('error', 'Erro!', message.message)
        }
      },
      async atualizarStatus (valor) {
        const chave = 'PAPEL_SEGURANCA_STATUS'

        try {
          loader({active: true, text: 'Atualizando status...'})
          await CartorioConfigService.updateByChave({ chave, valor })

          this.$toast.success('Status de papel atualizado com sucesso!', {
            position: 'top-right',
            duration: 5000
          })
        } catch (error) {
          let message
          if (error.response) {
            message = getErrors(error.response)
          } else {
            message = getErrors(error)
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      async atualizarAlerta () {
        try {
          loader({active: true, text: 'Atualizando...'})
          const impressos = {...this.config.impressos.papeis, ...this.config.impressos.selos}
          await CartorioConfigService.bulkUpdateByChave(impressos)

          this.modal.alerta = false

          this.$toast.success('Alerta de papel atualizado com sucesso!', {
            position: 'top-right',
            duration: 5000
          })
        } catch (error) {
          let message
          if (error.response) {
            message = getErrors(error.response)
          } else {
            message = getErrors(error)
          }

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      tipoImpressoToAlerta
    }
  }
</script>

<style lang="scss">
@import '../../../scss/_utilities/exports';

  .PapelSegurancaLote {
    &_table {
      &--header {
        background-color: #01bfa5;
        white-space: nowrap;
        text-align: start;
      }
    }
  }

  .btn-alerta {
    color: #fff !important;
    background: #6c757d;
    border-color: #6c757d;
  }

  .btn-alerta:active {
    background-color: #545b62 !important;
    border-color: #4e555b !important;
  }

  .btn-alerta:hover {
    background-color: #5a6268;
    border-color: #545b62;
  }

  .btn-alerta:focus {
    background-color: #5a6268;
    border-color: #545b62;
  }

  .dropdown-menu {
    min-width: 1rem !important;
    width: 100% !important;
  }

  .dropdown-item {
    font-size: pxToRem(13) !important;
    padding: 0.25rem 0.7em !important;
  }

  .dropdown-item:hover {
    background-color: #5897FB !important;
    color: #FFFFFF !important;
  }

  .table th, .table td {
    padding: 0.55rem;
  }

  .progress-bar {
    width: 100%;
    height: 100%;
    background-color: #01BFA5;
  }

  .pointer {
    cursor: pointer;
  }

  .tipo-impresso-column {
    width: 55%;
  }

  .acao-column {
    width: 110px;
  }

</style>
